import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const LocationsCustomMessage = ({ message }) => (
  <Box
    style={{
      marginBottom: '23px'
    }}
    data-testid="custom-message"
  >
    <Typography>{message}</Typography>
  </Box>
);

LocationsCustomMessage.propTypes = {
  message: PropTypes.string
};
export default LocationsCustomMessage;
